import {
	MenuItem,
	Typography,
	Divider,
	Popper,
	Grow,
	Paper,
	MenuList,
	ClickAwayListener
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import {
	VIEWER,
	REMOVE_ACCESS,
	INCLUDE_DATA,
	EXCLUDE_DATA,
	INCLUDEDATA,
	EXCLUDEDATA,
	REMOVEACCESS
} from 'constants/constant';
import { deepClone } from 'helper/helper';
import removeAccessMenuStyle from './RemoveAccessMenu.style';
import { setUsersToRemoveAccess } from '../Dashboard/Dashboard.actions';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const RemoveAccessMenu = (props) => {
	const {
		index,
		updateAccessForUser,
		open,
		anchorEl,
		handleClose,
		additionalMenuOption,
		isCustomDS = false
	} = props;
	const menuClasses = removeAccessMenuStyle();
	const dispatch = useDispatch();

	const [access, setAccess] = useState('viewer');

	const usersToRemoveAccess = useSelector((state) => state.dashboardReducer.usersToRemoveAccess);

	const stopPropagation = (event) => {
		event.stopPropagation();
	};

	const handleViewerSelection = (event) => {
		stopPropagation(event);
		const user = usersToRemoveAccess.filter((user) => updateAccessForUser.email !== user.email);
		dispatch(setUsersToRemoveAccess(user));
		setAccess('viewer');
		handleClose(event);
	};

	const handleRemoveAccessSelection = (event) => {
		stopPropagation(event);
		setAccess(REMOVEACCESS);
		const userIndex = usersToRemoveAccess.findIndex(
			(user) => updateAccessForUser.email === user.email
		);
		let user = deepClone(usersToRemoveAccess);
		if (userIndex === -1) {
			user.push({
				email: updateAccessForUser.email,
				removeAccess: true
			});
		} else {
			user[userIndex].email = updateAccessForUser.email;
			user[userIndex].removeAccess = true;
			delete user[userIndex].isDataIncluded;
		}
		dispatch(setUsersToRemoveAccess(user));
		handleClose(event);
	};

	const handleIncludeDataSelection = (event) => {
		stopPropagation(event);
		setAccess(INCLUDEDATA);
		const userIndex = usersToRemoveAccess.findIndex(
			(user) => updateAccessForUser.email === user.email
		);
		let user = deepClone(usersToRemoveAccess);
		if (userIndex === -1) {
			user.push({
				email: updateAccessForUser.email,
				isDataIncluded: true
			});
		} else {
			user[userIndex].email = updateAccessForUser.email;
			user[userIndex].isDataIncluded = true;
			delete user[userIndex].removeAccess;
		}
		dispatch(setUsersToRemoveAccess(user));
		handleClose(event);
	};

	const handleExcludeDataSelection = (event) => {
		stopPropagation(event);
		setAccess(EXCLUDEDATA);
		const userIndex = usersToRemoveAccess.findIndex(
			(user) => updateAccessForUser.email === user.email
		);
		let user = deepClone(usersToRemoveAccess);
		if (userIndex === -1) {
			user.push({
				email: updateAccessForUser.email,
				isDataIncluded: false
			});
		} else {
			user[userIndex].email = updateAccessForUser.email;
			user[userIndex].isDataIncluded = false;
			delete user[userIndex].removeAccess;
		}
		dispatch(setUsersToRemoveAccess(user));
		handleClose(event);
	};

	useEffect(() => {
		if (open) {
			const user = usersToRemoveAccess.filter((user) => user.email === updateAccessForUser.email);
			if (user.length > 0) {
				if (user[0].removeAccess) {
					setAccess(REMOVEACCESS);
				} else if (user[0].isDataIncluded === true) {
					setAccess(INCLUDEDATA);
				} else {
					setAccess(EXCLUDEDATA);
				}
			} else {
				setAccess('viewer');
			}
		}
	}, [open]);

	const getAdditionalOption = () => {
		if (additionalMenuOption === '') {
			return null;
		}
		if (additionalMenuOption === INCLUDEDATA) {
			return (
				<MenuItem
					key={`include-data-${index}`}
					id={`include-data-${index}`}
					className={menuClasses.menuItems}
					onClick={(e) => {
						handleIncludeDataSelection(e);
					}}>
					<CheckIcon
						className={
							access === INCLUDEDATA ? menuClasses.menuIcon : menuClasses.hideIcon
						}></CheckIcon>
					<Typography className={menuClasses.menuLabel}>{INCLUDE_DATA}</Typography>
				</MenuItem>
			);
		}
		return (
			<MenuItem
				key={`exclude-data-${index}`}
				id={`exclude-data-${index}`}
				className={menuClasses.menuItems}
				disabled={isCustomDS}
				onClick={(e) => {
					handleExcludeDataSelection(e);
				}}>
				<CheckIcon
					className={
						access === EXCLUDEDATA ? menuClasses.menuIcon : menuClasses.hideIcon
					}></CheckIcon>
				<Typography className={menuClasses.menuLabel}>{EXCLUDE_DATA}</Typography>
			</MenuItem>
		);
	};

	return (
		<Popper
			open={open}
			anchorEl={anchorEl}
			role={undefined}
			placement="right-end"
			transition
			disablePortal>
			{({ TransitionProps }) => (
				<Grow {...TransitionProps}>
					<Paper style={{ transform: `translate(18px, 100px)`, width: '160px' }}>
						<ClickAwayListener onClickAway={handleClose}>
							<MenuList disablePadding autoFocusItem={true} id={`remove-access-${index}`}>
								<MenuItem
									key={`viewer-${index}`}
									id={`viewer-${index}`}
									className={menuClasses.menuItems}
									onClick={(e) => {
										handleViewerSelection(e);
									}}>
									<CheckIcon
										className={
											access === 'viewer' ? menuClasses.menuIcon : menuClasses.hideIcon
										}></CheckIcon>
									<Typography className={menuClasses.menuLabel}>{VIEWER}</Typography>
								</MenuItem>
								<Divider></Divider>
								{getAdditionalOption()}
								<MenuItem
									key={`remove-access-${index}`}
									id={`remove-access-${index}`}
									className={menuClasses.menuItems}
									onClick={(e) => {
										handleRemoveAccessSelection(e);
									}}>
									<CheckIcon
										className={
											access === REMOVEACCESS ? menuClasses.menuIcon : menuClasses.hideIcon
										}></CheckIcon>
									<Typography className={menuClasses.menuLabel}>{REMOVE_ACCESS}</Typography>
								</MenuItem>
							</MenuList>
						</ClickAwayListener>
					</Paper>
				</Grow>
			)}
		</Popper>
	);
};

RemoveAccessMenu.propTypes = {
	anchorEl: PropTypes.object
};

export default RemoveAccessMenu;
